import _map from 'lodash/map'

import { LicenseSpecialStatuses } from './styles'

function getStatusAsComponent(status: string) {
  return <LicenseSpecialStatuses key={status}>{status}</LicenseSpecialStatuses>
}

interface LicenseStatusesProps {
  license: Record<string, any>
  rootDomainId: string | null
}

function LicenseStatuses({ license, rootDomainId }: LicenseStatusesProps) {
  const statuses = []
  const rma = license.enabled === false
  if (rma) statuses.push('RMA')
  const imported =
    !!license.purchaserDomainId && license.purchaserDomainId !== rootDomainId
  if (imported) statuses.push('Imported')
  const availableLicenseImported =
    !!license.domainId && license.domainId !== rootDomainId
  const activatedLicenseImported =
    !!license.homeRootDomainId && license.homeRootDomainId !== rootDomainId
  const youPurchasedLicense = license.purchaserDomainId === rootDomainId
  const transferred =
    (availableLicenseImported || activatedLicenseImported) &&
    youPurchasedLicense
  if (transferred) statuses.push('Transferred')

  return statuses.length ? (
    <div>{_map(statuses, getStatusAsComponent)}</div>
  ) : null
}

export default LicenseStatuses
